import styled from 'styled-components';

import { token, Text } from '@zillow/constellation';

export const StyledContainer = styled.div`
    max-height: 500px;
    overflow-y: scroll;
`;

export const StyledText = styled(Text)`
    background: ${({ odd }) => odd && token('colors.coolGray100')};
`;
